// InvoicePhaseBase Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'

import InvoiceUtil from '../../../lib/invoiceutil.js'
import Button from '../../../common/common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import FormAutoComplete from '../../../common/form/auto_complete/auto_complete.jsx'
import InvoiceViewItem from '../invoice_view_item/invoice_view_item.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import DialogPhaseSetting from '../../../common/dialog/dialog_phase_setting/dialog_phase_setting.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'

class InvoicePhaseBase extends Component {
  static get propTypes () {
    return {
      phase: PropTypes.object,
      budget: PropTypes.object,
      onChange: PropTypes.func,
      onDeleteSubtotal: PropTypes.func,
      onItemCreate: PropTypes.func,
      onItemUpdate: PropTypes.func,
      onItemRemove: PropTypes.func,
      showDefaultVat: PropTypes.bool,
      vatRate: PropTypes.number,
      isLocked: PropTypes.bool,
      isTypeActual: PropTypes.bool,
      disabledEdit: PropTypes.bool,
      isCredit: PropTypes.bool,
      onSave: PropTypes.func,
      onUpdateTotal: PropTypes.func,
      onRemove: PropTypes.func,
      onMoveItem: PropTypes.func,
      onDragStart: PropTypes.func,
      onDragEnd: PropTypes.func,
      onItemExpenseCreate: PropTypes.func,
      onItemExpenseUpdate: PropTypes.func,
      onItemExpenseDelete: PropTypes.func,
      processPhaseSelect: PropTypes.func,
      isItemDragging: PropTypes.bool,
      projectUsers: PropTypes.array,
      vatLevels: PropTypes.array,
      isFinal: PropTypes.bool,
      onRemoveSubItem: PropTypes.func,
      projectTitle: PropTypes.string,
      contactName: PropTypes.string,
      onCopy: PropTypes.func,
      isPaid: PropTypes.bool,
      onUpdateItemReorder: PropTypes.func,
      getItemPosition: PropTypes.func,
      showRate: PropTypes.bool,
      showTax: PropTypes.bool,
      taxRateVatOptions: PropTypes.array,
      showVatAutocomplete: PropTypes.bool,
      onCreateTaxRate: PropTypes.func,
      showLabelType: PropTypes.bool,
      showRateWithoutTax: PropTypes.bool,
      showActivity: PropTypes.bool,
      isQuickbookConnected: PropTypes.bool,
      quickbookItems: PropTypes.array,
      reloadQuickbookItems: PropTypes.func,
      isDiscountPhase: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      phase: null,
      budget: null,
      onChange: null,
      onDeleteSubtotal: null,
      onItemCreate: null,
      onItemUpdate: null,
      onItemRemove: null,
      showDefaultVat: false,
      vatRate: 0,
      isLocked: false,
      isTypeActual: false,
      disabledEdit: false,
      isCredit: false,
      onSave: null,
      onUpdateTotal: null,
      onRemove: null,
      onMoveItem: null,
      onDragStart: null,
      onDragEnd: null,
      onItemExpenseCreate: null,
      onItemExpenseUpdate: null,
      onItemExpenseDelete: null,
      processPhaseSelect: null,
      projectUsers: [],
      vatLevels: [],
      isFinal: false,
      onRemoveSubItem: null,
      projectTitle: '',
      contactName: '',
      onCopy: null,
      isPaid: false,
      onUpdateItemReorder: null,
      getItemPosition: null,
      showRate: false,
      showTax: false,
      taxRateVatOptions: [],
      showVatAutocomplete: false,
      onCreateTaxRate: null,
      showLabelType: false,
      showRateWithoutTax: false,
      showActivity: false,
      isQuickbookConnected: false,
      quickbookItems: [],
      reloadQuickbookItems: null,
      isDiscountPhase: null
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      dataDate: null,
      editable: false
    }

    this.data = {
      phaseKeyword: ''
    }

    this._references = {
      confirmInvoiceDelete: React.createRef(),
      phaseSettingDialog: React.createRef()
    }
  }

  render () {
    const phase = this.props.phase

    return (
      <div className='bdgtphase'>
        <div className='phasepanel'>
          {this._renderPhaseHeader()}
          {phase.showAdd && this._renderActivityAction()}
          {this._renderPhaseGroups()}
        </div>
        <div className='phaseactions' />
      </div>
    )
  }

  /* Event handlers */
  _onSave () {
    if (this.props.onSave) {
      this.props.onSave(this.props.phase)
    }
  }

  _onChange () {
    if (this.props.onChange) {
      this.props.onChange(this.props.phase)
    }
  }

  _onChangeActivity (group, activity) {
    const phase = this.props.phase
    group.items.map((obj, _objIdx) => {
      if (obj.dragId === activity.dragId) {
        obj = activity
      }
    })

    if (activity.type === 'subtotal') {
      // Called when activity type is changed to subtotal
      this._calculateGroupSubtotal(group)
      const groupId = phase.groups.length + 1
      const newActv = this._createNewActivity('expense', phase.id, groupId)

      phase.groups.push({
        id: groupId,
        items: [newActv]
      })
    }

    this._onChange(phase)
  }

  _calculateGroupSubtotal (group) {
    let total = 0
    group.items.map((item, _idx) => {
      if (item.type === 'subtotal') {
        item.total = total
      } else {
        total += parseFloat(item.total)
      }
    })
  }

  _onSaveActivity (group, activity) {
    group.items.map((obj) => {
      if (obj.title === activity.title) {
        obj = activity
      }
    })

    this._onSave(this.props.phase)
  }

  _onInsertItemInMiddle (item, type, e) {
    let currItemIdx = 0
    if (this.props.phase.groups.length > 0) {
      this.props.phase.groups[0].items.map((obj, idx) => {
        if (item.dragId === obj.dragId) {
          currItemIdx = idx
        }
      })
    }

    if (type === 'pagebreak') {
      this._onAddPageBreaker(type, currItemIdx + 1, e)
    } else {
      this._onAddPhaseItem(type, currItemIdx + 1, e)
    }
  }

  _onAddPhaseItem (type, insertIdx, e) {
    e.preventDefault()

    const phase = this.props.phase
    phase.showAdd = false
    phase.editable = false

    if (phase.groups.length === 0) {
      phase.groups.push({
        id: 0,
        items: []
      })
    }

    const lastIndex = phase.groups.length - 1
    const group = phase.groups[lastIndex]

    const activity = this._createNewActivity(type, phase.id, group.id)
    activity.orderNo = insertIdx + 1
    group.items.splice(insertIdx, 0, activity)

    group.items.map((item, _idx) => {
      item.showAdd = false
    })

    if (type === 'subtotal') {
      phase.groups.push({
        id: lastIndex + 1,
        items: []
      })

      if (this.props.onUpdateTotal) {
        this.props.onUpdateTotal()
      }

      if (this.props.onItemCreate) {
        this.props.onItemCreate(activity)
      }
    }

    // If inserted at middle of the phase items, update order number for all items
    if (insertIdx !== group.items.length && this.props.onUpdateItemReorder) {
      this.props.onUpdateItemReorder()
    }

    this._onSave()
  }

  _onAddPageBreaker (type, insertIdx, e) {
    e.preventDefault()

    const phase = this.props.phase
    phase.editable = false

    if (phase.groups.length === 0) {
      phase.groups.push({
        id: 0,
        items: []
      })
    }

    const lastIndex = phase.groups.length - 1
    const group = phase.groups[lastIndex]

    const activity = this._createNewActivity(type, phase.id, group.id)
    activity.title = 'pagebreak'
    activity.orderNo = insertIdx - 1

    group.items.splice(insertIdx, 0, activity)

    group.items.map((item, idx) => {
      item.showAdd = false
      item.orderNo = idx + 1
    })

    if (this.props.onItemCreate) {
      this.props.onItemCreate(activity)
    }

    // If inserted at middle of the phase items, update order number for all items
    if (insertIdx !== group.items.length && this.props.onUpdateItemReorder) {
      this.props.onUpdateItemReorder()
    }

    this._onSave()
  }

  _createNewActivity (type, phaseId, groupId) {
    return InvoiceUtil.createNewActivity(
      this.props.budget,
      type,
      phaseId,
      groupId,
      this.props.vatRate
    )
  }

  _onChangePhaseTitleInput (value) {
    const phase = this.props.phase
    phase.title = value

    this.setState({ dataDate: new Date() })
  }

  _onBlurPhaseTitleInput (_ev) {
    const phase = this.props.phase

    this._onSave(phase)
    this.setState({ dataDate: new Date() })
  }

  _onKeyPressTitleInput (ev) {
    const phase = this.props.phase

    if (ev.keyCode === 13 || ev.keyCode === 9) {
      // User press enter or tab
      ev.preventDefault()
      ev.stopPropagation()

      phase.editable = false
      this.setState({ dataDate: new Date() })
    } else if (ev.keyCode === 27) {
      phase.editable = false

      this._onSave()
      this.setState({ dataDate: new Date() })
    }
  }

  _moveToPhaseActivity () {
    const phase = this.props.phase
    if (phase.groups && phase.groups.length > 0) {
      if (phase.groups[0].items) {
        if (phase.groups[0].items.length === 0) {
          const activity = this._createNewActivity(
            'expense',
            phase.id,
            phase.groups[0].id
          )
          phase.groups[0].items.push(activity)
        } else {
          const item = phase.groups[0].items[0]
          item.editable = 'title'
        }
      }
    }
  }

  _onEditPhase (name) {
    const phase = this.props.phase
    phase.editable = name
    phase.bEdit = true

    this.setState({ dataDate: new Date() })
  }

  _updateBudgetTotal () {
    if (this.props.budget) {
      let budgetTotal = 0
      budgetTotal = _.sumBy(this.props.budget.phases, (phase) => {
        return phase.total
      })

      this.props.budget.total = budgetTotal
    }
  }

  _onClickDeletePhase () {
    if (
      !this.props.disabledEdit &&
      this._references.confirmInvoiceDelete.current
    ) {
      this._references.confirmInvoiceDelete.current.show()
    }
  }

  _onDeletePhase (ev) {
    ev.preventDefault()

    if (this.props.onRemove) {
      this.props.onRemove(this.props.phase)
    }
  }

  _onRemoveItem (curGroup, activity) {
    if (this.props.isTypeActual && activity.id && activity.external) {
      if (this.props.onItemRemove) {
        this.props.onItemRemove(activity)
      }
    } else {
      const phase = this.props.phase
      _.remove(curGroup.items, (item, _idx) => item.dragId === activity.dragId)

      if (curGroup.items.length === 0) {
        _.remove(phase.groups, (group, _idx) => group.id === curGroup.id)
      }

      if (this.props.onItemRemove) {
        this.props.onItemRemove(activity)
      }

      if (activity.type === 'subtotal') {
        this.props.onDeleteSubtotal()
      } else if (this.props.onUpdateTotal) {
        this.props.onUpdateTotal()
      } else {
        this._onSave()
      }

      this.setState({ dataDate: new Date() })
    }
  }

  _onUpdateItemEditable (group, activity) {
    const phase = this.props.phase

    if (this._isItemLastInGroup(group, activity.dragId)) {
      // If current group is the last group, then add new item, else find the next group and make
      // first item active
      if (this._isGroupLast(phase, group.id)) {
        group.items.push(
          this._createNewActivity('expense', phase.id, group.id)
        )
      } else {
        const nextGroupIndex = group.id + 1
        const nextGroup = phase.groups[nextGroupIndex]
        if (nextGroup) {
          if (nextGroup.items.length === 0) {
            nextGroup.items.push(
              this._createNewActivity('expense', phase.id, nextGroup.id)
            )
          } else {
            nextGroup.items[0].editable = 'title'
          }
        }
      }
    } else {
      const itemIdx = this._getItemIndex(group, activity.dragId)
      group.items.map((item, idx) => {
        if (idx === itemIdx + 1) {
          item.editable = 'title'
        }

        return ''
      })
    }
  }

  _onUpdateSubtotal (group, activity) {
    let total = 0
    group.items.map((item, _idx) => {
      if (item.type === 'subtotal') {
        item.total = total
      } else {
        total += item.total
      }
    })

    if (this.props.onItemUpdate) {
      this.props.onItemUpdate(activity, 'total')
    }
  }

  _getItemIndex (group, itemDragId) {
    let itemIdx = 0
    group.items.map((item, idx) => {
      if (item.dragId === itemDragId) {
        itemIdx = idx
      }
      return ''
    })

    return itemIdx
  }

  _isItemLastInGroup (group, itemDragId) {
    const itemsCount = group.items.length
    if (itemsCount === 0) {
      return true
    }

    let lastItemIndex = itemsCount - 1
    const lastItem = group.items[lastItemIndex]
    if (lastItem.type === 'subtotal') {
      lastItemIndex = itemsCount > 1 ? itemsCount - 2 : -1
    }

    return this._getItemIndex(group, itemDragId) === lastItemIndex
  }

  _isGroupLast (phase, groupIndex) {
    return phase.groups.length === groupIndex + 1
  }

  _handleSearchPhase (keyword) {
    this.props.phase.title = keyword
    this.data.phaseKeyword = keyword
    this.setState({ dataDate: new Date() })
  }

  _handlePhaseTitleSelect (obj) {
    const phase = this.props.phase
    phase.title = obj.label
    phase.editable = false

    this.data.phaseKeyword = ''

    // If activities are empty then copy from invoice budget phase
    if (
      phase.groups.length === 1 &&
      phase.groups[0].items.length === 0 &&
      this.props.processPhaseSelect
    ) {
      this.props.processPhaseSelect(phase.title, (phaseItems) => {
        if (phaseItems) {
          phase.groups[0].items = phaseItems
          this._moveToPhaseActivity()
        }

        this._onSave()
        this.setState({ dataDate: new Date() })
      })
    } else {
      this._onSave()
      this.setState({ dataDate: new Date() })
    }

    this._onSave()
    this.setState({ dataDate: new Date() })
  }

  _handlePhaseTitleBlur () {
    const phase = this.props.phase

    this.data.phaseKeyword = ''
    phase.editable = phase.bEdit ? false : ''

    this._onSave()
    this.setState({ dataDate: new Date() })
  }

  _onSettings (phase, e) {
    e.preventDefault()

    if (this._references.phaseSettingDialog.current) {
      this._references.phaseSettingDialog.current.show(
        this.props.projectTitle,
        this.props.contactName,
        phase
      )
    }
  }

  _onDelete (ev) {
    ev.preventDefault()

    if (this.props.onRemove && this._references.phaseSettingDialog.current) {
      this._references.phaseSettingDialog.current.hide()
      this.props.onRemove(this.props.phase)
    }
  }

  _onCopy (ev) {
    ev.preventDefault()
    if (this.props.onCopy && this._references.phaseSettingDialog.current) {
      this._references.phaseSettingDialog.current.hide()
      this.props.onCopy(this.props.phase)
    }
  }

  /* Private functions */
  _renderPhaseHeader () {
    const phase = this.props.phase
    const isFinal = this.props.isFinal
    const isPaid = this.props.isPaid
    const phaseLen = this.props.budget.phases.length
    const isTypeActual = this.props.isTypeActual
    const bShowCopy = !isTypeActual && !phase.editable && !isFinal && !isPaid
    const _hdrCls = this.props.disabledEdit
      ? 'phaseheader disabled'
      : 'phaseheader'

    return (
      <div className={_hdrCls}>
        <div className='phaseheader-inner'>
          {!phase.editable && !isFinal && phaseLen > 1 && isTypeActual && (
            <span
              className='phaseheader-close'
              onClick={this._onClickDeletePhase.bind(this)}
            >
              <i className='icon icon-phase-close' />
            </span>
          )}
          {bShowCopy && (
            <div className='phaseheader-hovercontent'>
              <IconButton
                icon='common-action-setting'
                size='small'
                onClick={this._onSettings.bind(this, phase)}
              />
            </div>
          )}
          <div className='cont'>
            <div className='col coltitle'>{this._renderPhaseTitle()}</div>
            <div className='col colprogress' />
            <div className='col colbudget'>&nbsp;</div>
            <div className='col colspent'>
              {phase.total !== 0 ? (
                <span className='spent'>
                  <PriceText value={phase.total} />
                </span>
              ) : (
                ''
              )}
            </div>
          </div>
          <ConfirmDelete
            ref={this._references.confirmInvoiceDelete}
            title='invoice.view.confirmPhaseDeleteInfo'
            onClickOk={this._onDeletePhase.bind(this)}
          />
          {bShowCopy && (
            <DialogPhaseSetting
              ref={this._references.phaseSettingDialog}
              showdelete={!phase.editable && !isFinal && phaseLen > 1}
              deleteMessage='invoice.view.confirmPhaseDeleteInfo'
              onDelete={this._onDelete.bind(this)}
              onCopy={this._onCopy.bind(this)}
              phase={phase}
            />
          )}
        </div>
        {!phase.showAdd && (
          <div className='addsplitter'>
            <div
              className='hovericon addaction'
              onClick={this._onShowPhaseAddAction.bind(this, true)}
            >
              <span className='iconcont'>
                <i className='icon icon-common-itemadd' />
              </span>
            </div>
            <div className='line' />
          </div>
        )}
      </div>
    )
  }

  _renderPhaseSubtotal () {
    return (
      <div className='phasesubtotal'>
        <div className='col colsubtotal'>
          <span className='label'>
            <IntlMessage ident='project.viewBudget.labelSubTotal' />
          </span>
          <span className='value'>
            <PriceText value={this.props.phase.total} />
          </span>
        </div>
      </div>
    )
  }

  _renderPhaseTitle () {
    const phase = this.props.phase
    if (phase.editable === 'title') {
      const options = []
      const _className = classnames(
        'bdgtphaseinput bdgtphaseinput_autocomplete',
        {}
      )

      return (
        <span className={_className}>
          <FormAutoComplete
            label='invoice.view.phaseInputPlaceholder'
            name='title'
            autoFocus
            value={phase.title}
            displayValue={phase.title}
            options={options}
            onChange={this._handleSearchPhase.bind(this)}
            onSelect={this._handlePhaseTitleSelect.bind(this)}
            onBlur={this._handlePhaseTitleBlur.bind(this)}
            onKeyDown={this._onKeyPressTitleInput.bind(this)}
            hideAdd
            hasAutoSelect={false}
          />
        </span>
      )
    }

    return (
      <span className='title' onClick={this._onEditPhase.bind(this, 'title')}>
        {phase.title ? (
          phase.title
        ) : (
          <span className='label'>
            <IntlMessage ident='invoice.view.phaseInputPlaceholder' />
          </span>
        )}
      </span>
    )
  }

  _renderPhaseGroups () {
    const phase = this.props.phase
    const _className = classnames('itemgroup', {
      hasitemdragging: this.props.isItemDragging
    })

    return phase.groups.map((group, idx) => {
      return (
        <div key={idx}>
          <div className={_className}>
            {this._renderPhaseGroupContent(group)}
          </div>
        </div>
      )
    })
  }

  _renderPhaseGroupContent (group) {
    if (group.items && group.items.length > 0) {
      return group.items.map((item, idx) => {
        return (
          <InvoiceViewItem
            key={idx}
            item={item}
            showDefaultVat={this.props.showDefaultVat}
            vatLevels={this.props.vatLevels}
            isLocked={this.props.isLocked}
            isTypeActual={this.props.isTypeActual}
            isCredit={this.props.isCredit}
            disabledEdit={this.props.disabledEdit}
            isQuickbookConnected={this.props.isQuickbookConnected}
            quickbookItems={this.props.quickbookItems}
            onChange={this._onChangeActivity.bind(this, group, item)}
            onSave={this._onSaveActivity.bind(this, group, item)}
            onRemove={this._onRemoveItem.bind(this, group, item)}
            onUpdateEditable={this._onUpdateItemEditable.bind(
              this,
              group,
              item
            )}
            onUpdateSubtotal={this._onUpdateSubtotal.bind(this, group, item)}
            onUpdateTotal={this.props.onUpdateTotal}
            onMoveItem={this.props.onMoveItem}
            onItemUpdate={this.props.onItemUpdate}
            onItemCreate={this.props.onItemCreate}
            onDragStart={this.props.onDragStart}
            onDragEnd={this.props.onDragEnd}
            processNextActivityId={this._processNextActivityId.bind(this)}
            projectUsers={this.props.projectUsers}
            onItemExpenseCreate={this.props.onItemExpenseCreate}
            onItemExpenseUpdate={this.props.onItemExpenseUpdate}
            onItemExpenseDelete={this.props.onItemExpenseDelete}
            onRemoveSubItem={this.props.onRemoveSubItem}
            getItemIndex={this._getItemIndex.bind(this, group)}
            onInsertItemInMiddle={this._onInsertItemInMiddle.bind(this, item)}
            getItemPosition={this.props.getItemPosition}
            showRate={this.props.showRate}
            showTax={this.props.showTax}
            showRateWithoutTax={this.props.showRateWithoutTax}
            showActivity={this.props.showActivity}
            showVatAutocomplete={this.props.showVatAutocomplete}
            taxRateVatOptions={this.props.taxRateVatOptions}
            onCreateTaxRate={this.props.onCreateTaxRate}
            showLabelType={this.props.showLabelType}
            hidePagebreak={group.items.length === idx + 1}
            reloadQuickbookItems={this.props.reloadQuickbookItems}
            isDiscountPhase={this.props.isDiscountPhase}
            budget={this.props.budget}
          />
        )
      })
    }

    return ''
  }

  _processNextActivityId () {
    if (this.props.budget) {
      return this.props.budget.lastActivityId++
    }

    return 0
  }

  _renderActivityAction () {
    if (this.props.disabledEdit || this.props.isLocked) {
      return ''
    }

    return (
      <div className='phaseactions'>
        <span
          className='phaseitem-close'
          onClick={this._onShowPhaseAddAction.bind(this, false)}
        >
          <i className='icon icon-phase-close' />
        </span>
        <div className='action'>
          <Button
            className='button_phase'
            title='invoice.view.expense'
            onClick={this._onAddPhaseItem.bind(this, 'expense', 0)}
          />
          <Button
            className='button_phase'
            title='invoice.view.text'
            onClick={this._onAddPhaseItem.bind(this, 'text', 0)}
          />
        </div>
      </div>
    )
  }

  _onShowPhaseAddAction (bShowAdd) {
    const phase = this.props.phase
    phase.showAdd = bShowAdd

    this.setState({ dataDate: new Date() })
  }
}

export default InvoicePhaseBase
